import { createAsyncThunk } from "@reduxjs/toolkit";

import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { type AsyncThunkCreator } from "../../../index";
import { setNumberOfUnreadNotifications } from "../reducer";
import { NOTIFICATIONS_REDUCER_NAME } from "../types";
import { countUnreadNotifications } from "./countUnreadNotifications";

type Payload = void;

export const refreshUnreadNotifications = createAsyncThunk<void, Payload, AsyncThunkCreator<string>>(
  `${NOTIFICATIONS_REDUCER_NAME}/refreshUnreadNotifications`,
  async (_payload, { dispatch, getState, extra: { db, auth } }) => {
    const currentUser = await getLoggedUser(auth);
    // Same type filter the list was last read with — a badge counting types the drawer filters out
    // is a badge the user has no way of clearing.
    const { typeFilter } = getState().notifications;

    const count = await countUnreadNotifications(db, currentUser.id, typeFilter);

    if (count !== null) {
      dispatch(setNumberOfUnreadNotifications(count));
    }
  },
);
